import { render, staticRenderFns } from "./editVivaMarkForm.vue?vue&type=template&id=6109c12c&"
import script from "./editVivaMarkForm.vue?vue&type=script&lang=js&"
export * from "./editVivaMarkForm.vue?vue&type=script&lang=js&"
import style0 from "./editVivaMarkForm.vue?vue&type=style&index=0&id=6109c12c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports